import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

const getCellByColumnRef = ({ cells, columnRef }: { cells: Record<string, ICell>, columnRef: string }) => {
  const cellArray = Object.values(cells);
  const foundCell = cellArray.find(cell => cell.columnRef === columnRef);
  return foundCell || null;
};

export default getCellByColumnRef;
